import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  FontAwesomeModule,
  IconDefinition,
} from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { IUser } from '../../models/dtos/get/user.interface';
import {
  faHeadset,
  faSignOutAlt,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-user-circle',
  imports: [TranslateModule, FontAwesomeModule, RouterLink, NgbDropdownModule],
  templateUrl: './user-circle.component.html',
  styleUrl: './user-circle.component.scss',
})
export class UserCircleComponent {
  @Input() public user: IUser = null!;
  public faHeadset: IconDefinition = faHeadset;
  public faSignOutAlt: IconDefinition = faSignOutAlt;
  public faUserCircle: IconDefinition = faUserCircle;
}
